import { render, staticRenderFns } from "./Deskew.vue?vue&type=template&id=2e464c03"
import script from "./Deskew.vue?vue&type=script&lang=js"
export * from "./Deskew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports